export function timeFix() {
  const time = new Date()
  const hour = time.getHours()
  return hour < 9 ? '早上好' : hour <= 11 ? '上午好' : hour <= 13 ? '中午好' : hour < 20 ? '下午好' : '晚上好'
}

/**
 * 获取身份证/ 企业证件 / 授权有效期时间状态判断
 * @param {string} value "长期有效" | "yyyy-MM-dd"
 * @param {number} nearDays 默认 30
 * @returns { 'normal' | 'near' | 'expired' | 'invalid'}
 */
export function getTimeStatus(value, nearDays = 30) {
  if (!value) {
    return 'invalid';
  }

  // 1️长期有效
  if (value === '长期有效') {
    return 'normal';
  }

  // 2️日期格式校验（yyyy-MM-dd）
  const datePattern = /^\d{4}-\d{2}-\d{2}$/;
  if (!datePattern.test(value)) {
    return 'invalid';
  }

  // 3️构造日期（当天 00:00）
  const endDate = new Date(`${value} 00:00:00`);
  if (isNaN(endDate.getTime())) {
    return 'invalid';
  }

  // 4️今天（00:00）
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const diffTime = endDate.getTime() - today.getTime();
  const diffDays = diffTime / (1000 * 60 * 60 * 24);

  if (diffDays < 0) {
    return 'expired';
  }

  if (diffDays <= nearDays) {
    return 'near';
  }

  return 'normal';
}

// 滚动到页面顶部
export function scrollToTop(smooth = true) {
  const el =
    document.scrollingElement ||
    document.documentElement ||
    document.body;

  el.scrollTo({
    top: 80,
    behavior: smooth ? "smooth" : "auto",
  });
}

/**
 * 空值统一转undefined，用于触发表单placeholder显示
 * @param {*} value
 * @returns {*}
 */
export function emptyToUndefined(value) {
  return value == null || value === ""
    ? undefined
    : value;
}